import React from "react";
import { Avatar, Dropdown, Button } from "antd";
import UserMenu from "./menu/user-menu/UserMenu";
import { UserOutlined } from "@ant-design/icons";
import { useAuth } from "../utils/authUtils";
import { useDarkMode } from "src/context/DarkModeContext";

interface ProfileProps {
  handleSignOut: () => Promise<void>;
}

const Profile: React.FC<ProfileProps> = ({ handleSignOut }) => {
  const { user, loading, signInWithGoogle } = useAuth(); // Use the useAuth hook
  const { isDarkMode } = useDarkMode();

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      {user ? (
        <div>
          {/* Dropdown Menu */}
          <Dropdown
            dropdownRender={(menu) => (
              <div
                style={{
                  backgroundColor: isDarkMode ? "#121212" : "#ffffff",
                }}
              >
                <UserMenu handleSignOut={handleSignOut} isDarkMode={isDarkMode} />
              </div>
            )}
            trigger={["click"]}
            placement="bottomRight"
          >
            <Avatar
              src={user.photoURL || undefined}
              icon={user.photoURL ? undefined : <UserOutlined />}
              alt="Profile"
              size={30}
              style={{
                cursor: "pointer",
                border: isDarkMode ? "1px solid white" : "1px solid black",
              }}
            />
          </Dropdown>
        </div>
      ) : (
        <Button
          type="text"
          icon={<UserOutlined />}
          size="large"
          style={{
            cursor: "pointer",
            border: isDarkMode ? "1px solid white" : "1px solid black",
            color: isDarkMode ? "white" : "black",
            padding: "0",
          }}
          onClick={signInWithGoogle}
        />
      )}
    </div>
  );
};

export default Profile;
